//
import { objectToQueryString } from "../../../helpers/objectToQueryString";
import { API } from "../../api";
async function getRelatedProducts(query) {
    // console.log("relatedProducts -> query", query);
    const url = process.env.LETS_TRADE_PRODUCT_URL ?? "";
    return await new API().apiGet({
        baseUrl: url,
        endpoint: `v2/product/related${objectToQueryString(query)}`, //
        // content: request,
    });
}
export { getRelatedProducts };
